import React from 'react'
import Skeleton from '@mui/material/Skeleton'
import cx from 'classnames'
import { searchTitles } from 'pages/search/PagedSearchResults'
import { range } from 'libraries/lodash'

const SearchResultsSkeleton = ({
  flavour,
  searchType,
  pageView = 'left',
  windowHeight,
  headerHeight,
  isDealwatch = false
}) => (
  <div className='relative'>
    <div
      className={cx(
        'w-100 overflow-y-auto bg-page-background flex justify-center scrolling-container',
        { 'flex-wrap': !isDealwatch }
      )}
      style={{ maxHeight: `${windowHeight - headerHeight}px` }}
    >
      <SearchResultsMainSkeleton {...{ flavour, searchType }} />
    </div>
  </div>
)

export const ResultItemSkeleton = () => (
  <li className='mt7 mb3'>
    <QuestionSkeleton />
    <PathBreadCrumbsSkeleton />
    <ExcerptSkeleton />
  </li>
)

const SearchResultsMainSkeleton = ({ flavour, searchType }) => {
  const title = searchTitles(flavour)[searchType] || 'Search results'

  return (
    <div className='grow-1 shrink-1 basis0 ph0 ma0 w-100'>
      <div className='min-vh-100 mb8 layout-width-constraint'>
        <div className='bb b--lite-grey'>
          <section className='bg-page-background'>
            <section className='f4 fw6 pb5 pt6'>{title}</section>
            <div className='bg-white pl6 pv3'>
              <div className='o-50'>
                <Skeleton
                  classes={{ root: 'w14 max-w-100 bg-cadet-blue ', text: 'f6 lh-title' }}
                />
              </div>
            </div>
          </section>
          <section>
            <ul className='flex flex-column list-reset list-item-reset pl0'>
              {range(0, 9).map((_, index) => (
                <ResultItemSkeleton key={index} />
              ))}
            </ul>
          </section>
        </div>
      </div>
    </div>
  )
}

const QuestionSkeleton = () => (
  <h2 className='ma0 lh-copy f5 fw6'>
    <Skeleton classes={{ root: 'w15 max-w-100 bg-dim-grey', text: 'f5 lh-title' }} />
  </h2>
)

const PathBreadCrumbsSkeleton = () => (
  <ul className='flex flex-wrap-m list-reset pl0 mt2 mb3'>
    {range(0, 3).map((_, index) => (
      <li key={index} className='f7 di mr6'>
        <div className='o-50'>
          <Skeleton classes={{ root: 'w12 bg-cadet-blue o-50', text: 'f5' }} />
        </div>
      </li>
    ))}
  </ul>
)

const ExcerptSkeleton = () => (
  <div className='w-100'>
    <Skeleton classes={{ root: 'w-100 bg-grey', text: 'f5' }} />
    <Skeleton classes={{ root: 'w-100 bg-grey', text: 'f5' }} />
    <Skeleton classes={{ root: 'w-100 bg-grey', text: 'f5' }} />
  </div>
)

export default SearchResultsSkeleton
